import { Component, Inject, OnInit } from '@angular/core';
import { Router, RouteReuseStrategy } from '@angular/router';
import { NB_AUTH_OPTIONS, NbAuthResult, NbAuthService, NbLogoutComponent } from '@nebular/auth';
import { TipoUsuario } from '../../../../../shared/Enums/TipoUsuario';

@Component({
  selector: 'ngx-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class NgxLogoutComponent extends NbLogoutComponent implements OnInit {
  redirectDelay: number = 0;
  provider: string = 'email';
  usuarioId = sessionStorage.getItem('usuarioId');
  tipoUsuario = sessionStorage.getItem('tipoUsuario');

  constructor(
    // protected service: NbAuthService,
    // private routeReuse: RouteReuseStrategy,

    private authService: NbAuthService,
    protected router: Router,
    @Inject(NB_AUTH_OPTIONS) protected config = {},
    ) {
      super(authService, config, router);

  }

  ngOnInit(): void {
    this.logout(this.provider);
  }


  excluirListaNegocioCache() {
    if (this.tipoUsuario !== TipoUsuario.Executivo) {
      caches.open(`negocio-cache-${this.usuarioId}`).then((cache) => {
        cache.delete(`/negocio-cache-${this.usuarioId}`).then((success) => { 
          console.log('Cache deletado:', success);
        }).catch(error => {
          console.error('Erro ao deletar cache:', error);
        });
      }).catch(error => {
        console.error('Erro ao abrir cache:', error);
      });
    }
  }

  logout(provider: string): void {
    sessionStorage.clear();
    this.authService.logout(provider).subscribe((result: NbAuthResult) => {
      // Sempre redirecionar para login, não usar result.getRedirect()
      this.excluirListaNegocioCache();
      setTimeout(() => {
        this.router.navigate(['/auth/login']);
      }, this.redirectDelay);
    });
  }
}
